/** The texts of a right (`access.rights.<key>.*`). */
export type RightField = 'title' | 'short' | 'impact' | 'desc' | 'drawer' | 'nodeHint';

/**
 * A text of a right with a fallback, so a key the page has no text for (a dead key like `cf_workflow_categories`, a key the backend added later) never shows as
 * `access.rights.x.y`: the short forms fall back to the title, the title to the key itself, the long descriptions to nothing.
 */
export function rightText(t: (key: string) => string, key: string, field: RightField = 'title'): string {
  const path = `access.rights.${key}.${field}`;
  const text = t(path);
  if (text !== path && text.length > 0) {
    return text;
  }
  if (field === 'desc' || field === 'drawer' || field === 'nodeHint') {
    return '';
  }
  if (field === 'title') {
    return key;
  }
  return rightText(t, key, 'title');
}
